import React from "react";
import { Guitar, Music2, Drum } from "lucide-react";
import { bandData } from "../mock";

const getInstrumentIcon = (instrument) => {
  switch (instrument.toLowerCase()) {
    case "guitar":
      return <Guitar size={32} className="text-[#ff6b35]" />;
    case "bass":
      return <Music2 size={32} className="text-[#4a5aff]" />;
    case "drums":
      return <Drum size={32} className="text-[#00d9ff]" />;
    default:
      return <Music2 size={32} className="text-white" />;
  }
};

const Members = () => {
  return (
    <section id="members" className="py-20 bg-[#0a0a0f]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Meet The Band
          </h2>
          <div className="w-24 h-1 bg-[#4a5aff] mx-auto" />
        </div>

        {/* Members Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {bandData.members.map((member) => (
            <div
              key={member.id}
              className="bg-[#1a1a2e] rounded-lg overflow-hidden hover:transform hover:scale-105 transition-all"
            >
              {/* Member Image */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a2e] via-transparent to-transparent" />
              </div>

              {/* Member Info */}
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-1">
                      {member.name}
                    </h3>
                    <p className="text-[#00d9ff] font-medium">
                      {member.instrument} • Age {member.age}
                    </p>
                  </div>
                  {getInstrumentIcon(member.instrument)}
                </div>
                <p className="text-white/70 leading-relaxed">
                  {member.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Members;
